import { render } from "./TeamRow.vue?vue&type=template&id=04935ffa&scoped=true"
import script from "./TeamRow.vue?vue&type=script&lang=js"
export * from "./TeamRow.vue?vue&type=script&lang=js"

import "./TeamRow.vue?vue&type=style&index=0&id=04935ffa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04935ffa"]])

export default __exports__